'use client';

import { cn } from '@repo/ui';
import { Fragment, type JSX } from 'react';
import type { IKaraokeActive } from './use-active-word-index';

interface IKaraokeTextProps {
  words: string[];
  active: IKaraokeActive;
  className?: string;
}

export function KaraokeText({ words, active, className }: IKaraokeTextProps): JSX.Element {
  if (words.length === 0) {
    return <span className={className} />;
  }
  return (
    <span className={className}>
      {words.map((raw, i) => {
        const w = raw.trim();
        if (!w) {
          return null;
        }
        const isActive = i === active.index && active.mode !== 'inactive';
        return (
          <Fragment
            // biome-ignore lint/suspicious/noArrayIndexKey: word list order is stable for a given text
            key={i}
          >
            <span
              className={cn(
                'inline-block rounded px-0.5 -mx-0.5 transition-colors duration-150 ease-out',
                isActive && active.mode === 'timings' && 'bg-yellow-200/70 dark:bg-yellow-500/30',
                isActive && active.mode === 'even' && 'text-red-500',
              )}
            >
              {w}
            </span>
            {i < words.length - 1 && ' '}
          </Fragment>
        );
      })}
    </span>
  );
}
